import React, { Component } from 'react';
import { withRouter, setCookie, login_check, loginUrl, pocketUrl, LoadingSpinner, getCookie, deleteCookie, isLogin } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";
import Swiper from 'swiper';
import 'swiper/css';
import Footer from './Footer';

//

class My extends Component {
   constructor(props) {
      super(props);
      this.swiper = null;
      this.state = {
         isLogin: false,   // 처음에 로딩 상태
         loading: true,
         tpoint: 0,
         rmonth: '',
         infoList: [],
         zzimList: [],
      };
   }
   componentDidMount() {
      this.fetchAccessCheck();
      $(document).on("click", function (e) {
         $(".info-toggle-btn.active").length > 0 &&
            ($(e.target).closest(".info-toggle-btn.active").length || $(".info-toggle-btn").removeClass("active"));
      });
      $(document).on("click", ".info-toggle-btn__icon", function () {
         $(this).closest(".info-toggle-btn").toggleClass("active");
      });

      $(document).on("click", ".info-toggle-btn__close", function () {
         $(this).closest(".info-toggle-btn").removeClass("active");
      });
      function closeComboBx() {
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").stop().fadeOut(200);
      }
      
   }

   async fetchAccessCheck() {
      const loginCheck = await login_check();
      const getToday = () => {
         const today = new Date();
         const year = today.getFullYear();
         const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
         const day = String(today.getDate()).padStart(2, '0');
         return `${year}-${month}-${day}`;
      };
      if (!loginCheck) {
         window.location.replace(loginUrl + '?ref=' + pocketUrl + '/My');
      }
      let pocketTodayQuizCookie = getCookie('pocketTodayQuiz');
      const publicUrl = process.env.PUBLIC_URL;
      let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + getToday() + '&word=' + pocketTodayQuizCookie + '&mode=quiz';
      if (
         pocketTodayQuizCookie !== undefined &&
         pocketTodayQuizCookie !== null &&
         pocketTodayQuizCookie !== ''
      ) {
         axios.get(quizCrossUrl).then(response => {
            if (response.data == 'OK' && pocketTodayQuizCookie) {
               deleteCookie('pocketTodayQuiz');
            }
         });
      }

      let quizWordUrl = publicUrl + '/api/getUserQuiz.php';
      let response = axios.get(quizWordUrl);
      this.setState({
         isLogin: loginCheck,
         loading: false,
         rmonth: (await response).data.info.rMonth,
         tpoint: (await response).data.tpoint,
         infoList: (await response).data.info,
         zzimList: (await response).data.zzim,
      });

   }

   handleButtonClick = async (targetIdx) => {
      const element = document.getElementById(`btn-${targetIdx}`);
      const isActive = element.classList.contains('active');

      this.setState(prevState => {
         const foundIndex = prevState.zzimList.findIndex(item => item.idx === targetIdx);

         if (foundIndex === -1) {
            console.error(`idx ${targetIdx}에 해당하는 항목이 없습니다.`);
            return null;
         }
         const updated = [...prevState.zzimList];
         updated[foundIndex] = {
            ...updated[foundIndex],
            uzzim: !updated[foundIndex].uzzim
         };
         const after = updated[foundIndex].uzzim;
         let md = 'setZzim';
         if (!after) md = 'unsetZzim';
         try {
            const ret = setWord(md, targetIdx);
            if (ret == 'setZzim') {
               element.className = 'zzim active';
            } else {
               element.className = 'zzim';
            }
            this.fetchAccessCheck();
         } catch (err) {
            console.error('버튼 클릭 처리 실패:', err);
         }
         return { zzimList: updated };
      });

   };
   componentDidUpdate(prevProps, prevState) {
      if (
         prevState.zzimList !== this.state.zzimList &&
         this.state.zzimList.length >= 2
      ) {
         setTimeout(() => {
            const container = document.querySelector('.wordSwiper .swiper-container');
            if (container) {
               if (this.swiper) {
                  this.swiper.update(); // 이미 존재하면 업데이트만
               } else {
                  this.initSwiper(); // 처음이면 초기화
               }
            } else {
               console.warn('swiper-container가 아직 DOM에 없습니다.');
            }
         }, 50);
      }
   }
   initSwiper() {
      if (this.swiper) return; // 한 번만 초기화
      this.swiper = new Swiper(".wordSwiper .swiper-container", {
         speed: 1e3,
         grabCursor: true,
         loop: false,
         slidesPerView: "auto",
         centeredSlides: false,
         centeredSlidesBounds: true,
         spaceBetween: 16,
         observer: false,
         observeParents: false,

      })
   }

   handleLogoutClick = () => {
      window.location.href = 'https://user.asiae.co.kr/snslogin/PocketLogout.htm';
   }
   render() {
      const { loading, isLogin, tpoint, rmonth, infoList, zzimList } = this.state;
      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "마이 포켓 - 지식포켓",
         "url": currentUrl,
      } 
      return loading ? <LoadingSpinner /> : (
         <>
            <Helmet>

               <title>마이 포켓 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="나의 퀴즈 기록과 찜한 용어를 한눈에! 마이 포켓에서 학습 성취를 확인하고 꾸준히 성장해보세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="마이 포켓 - 지식포켓" />
               <meta property="og:description" content="나의 퀴즈 기록과 찜한 용어를 한눈에! 마이 포켓에서 학습 성취를 확인하고 꾸준히 성장해보세요."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>               
               
            </Helmet>          
            <main id="contents" data-page="my" className="page--my no-search-btn">
               <div className="title-bx">
                  <h1 className="tit">마이 포켓</h1>
                  <p className="desc">내 포켓 속 지식 기록을 확인해 보세요</p>
               </div>
               <></>
               <section className="my-score">
                  <div className="txt-bx">
                     <p className="tit">{rmonth}월 퀴즈 점수</p>
                     <p className="txt">퀴즈를 통해 지식을 쌓아보세요!</p>


                     <div type="button" className="info-toggle-btn">
                        <button className="info-toggle-btn__icon" title="정보 보기"></button>
                        <div className="info-toggle-btn__toggle">
                           참여율과 정답률을 종합해<br />
                           100점 만점으로 환산했어요!
                           <button type="button" className="info-toggle-btn__close" title="정보 끄기"> </button>
                        </div>
                     </div>
                  </div>

                  <div className="score-bx">
                     <div class="score-bx__txt">
                        <p class="score">{tpoint}</p>
                        <p class="txt">Quiz Score</p>
                     </div>
                  </div>
               </section>

               <section className="my-quiz-history">
                  <div className="my-section__title">
                     <a href="/MyQuiz" className="tit">퀴즈 내역</a>
                     {(infoList.crossPercent == '100' && infoList.quizPercent == '100') ? (
                        <p className="desc"> <span className="d-inline-block">이번 달 현황!</span> <span className="d-inline-block">이대로라면 퀴즈 천재는 시간문제✌️</span> </p>
                     ) : (
                        <p className="desc"> <span className="d-inline-block">이번 달 현황!</span> <span className="d-inline-block">꾸준히 퀴즈에 도전해 보세요👍</span> </p>
                     )}
                  </div>

                  <ul className="quiz-history-state">
                     <li className="box">
                        <p className="title">오늘의<em> 용어 퀴즈 </em></p>
                        <p className="count"> <em>{infoList?.quiztotal}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">정답률</p>
                              <p className="num"><em>{infoList?.quizPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{ width: `${infoList?.quizPercent}%` }}></p></div>
                        </div>
                     </li>
                     <li className="box">
                        <div class="d-flex">
                        <p class="title"> 주간<em> 십자말풀이 </em> </p>
                           <div type="button" class="info-toggle-btn info-toggle-btn--gray">
                              <button class="info-toggle-btn__icon" title="정보 보기"></button>
                              <div class="info-toggle-btn__toggle">
                                 한 주가 두 달에 걸친 경우 <br />
                                 양쪽 달에 반영돼요.
                                 <button type="button" class="info-toggle-btn__close" title="정보 끄기"> </button>
                              </div>
                           </div>
                        </div>
                        <p className="count"> <em>{infoList?.crosstotal}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">정답률</p>
                              <p className="num"><em>{infoList?.crossPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{ width: `${infoList?.crossPercent}%` }}></p></div>
                        </div>
                     </li>
                  </ul>
               </section>

               {(zzimList && zzimList.length > 0) ? (
                  <section className="my-section zzim-word">
                     <div className="container">
                        <div className="my-section__title">
                           <a href="/MyZzim" className="tit">찜한 용어</a>
                        </div>

                        <div className="wordSwiper">
                           <div className="swiper-container">
                              <div className="swiper-wrapper">
                                 {zzimList.slice(0, 10).map((item, index) => (
                                    <div className="swiper-slide item">
                                       <article className="word-card">
                                          <button id={`btn-${item.idx}`} type="button" className={item.uzzim ? 'zzim active' : 'zzim'} onClick={(e) => {
                                             e.preventDefault();
                                             e.stopPropagation();
                                             if (this.isDragging) return; // 스와이프 중이면 무시
                                             this.handleButtonClick(item.idx)
                                          }}>
                                             <svg width="24" height="22" id={`svg-${item.idx}`} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                                                <use xlinkHref="#zzim"></use>
                                             </svg>
                                             <span className="sr-only">찜하기 해제</span>
                                          </button>
                                          <a href={item ? `/View/${item.idx}` : '#'} className="wrap">
                                             <p className="tit">
                                                <span>{item.title}</span>
                                             </p>
                                             <p className="eng">{item.subtitle}</p>
                                          </a>
                                       </article>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>

               ) : (
                  <section class="my-section zzim-word">
                     <div class="container">
                        <div class="my-section__title">
                           <p class="tit">찜한 용어</p>
                        </div>
                        <div class="word-null">
                           <p>찜한 용어가 없어요 😥</p>
                           <a class="btn" href="/WordList">용어 리스트 보기</a>
                        </div>
                     </div>
                  </section>
               )}


               <div className="container">
                  <button className="btn-logout" type="button" onClick={() => this.handleLogoutClick()}>
                     로그아웃
                  </button>
               </div>
            </main >
            <Footer />
         </>
      );
   }
}
async function setWord(md, idx) {
   const publicUrl = process.env.REACT_APP_POCKET_WWW;
   setCookie('JUMP_URI', publicUrl);
   try {
      const response = await axios.get(publicUrl + '/api/setWord.php?md=' + md + '&idx=' + idx);
      if (response.data == 'NO') {
         window.location.href = loginUrl;
      }
      return response.data;
   } catch (error) {
      console.log(error.message);
      return false;
   };
}
export default withRouter(My);